var msg = new Array();
msg['ERR_PRIVACY']='Вы должны принять заявление о конфиденциальности.';
msg['ERR_MISSINGFIELDS']='Заполните все обязательные поля';
msg['ERR_FILLEMAILFIELD']='Заполните поле электронной почты';
msg['ERR_USEREXISTS']='Пользователь  уже существует';
msg['ERR_INVALIDMAIL']='Неверный адрес электронной почты';
msg['ERR_CLIENTMANDATORYFIELDS']='Заполните все обязательные поля';
msg['ERR_NOSIZESELECTED']='Выберите размер';
msg['ERR_LOGINREQUIRED']='Введите Ваш Логин';
msg['ERR_LOGININVALID']='Неверный адрес электронной почты или пароль';
msg['ERR_CARRIERMISSING']='Вы должны сначала выбрать тип отправки';
msg['ERR_CARRIER_COST_MISSING']='Никакой платы для выбранной  страны и веса заказа..';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Заказ забронирован,информация об оплате за доставку будет отправлено вам по электронной почте.';
msg['MSG_ADDEDTOWISHLIST']='Товар добавлен в список Ваших пожеланий';
msg['MSG_ADDEDTOCART']='Продукты, добавленные в корзину';
msg['MSG_WAIT']='подождите пожалуйста...';
msg['MSG_SUBJECT_PRODUCTSHARE']=' Кто-то с Вами поделился';
msg['MSG_SENDER_PRODUCTSHARE']='Ваше имя';
msg['MSG_MESSAGE_PRODUCTSHARE']='Сообщение';
msg['MSG_MAILSENT']='E-Mail отправлено';
msg['MSG_MIXED_INTANGIBLE']='Этот продукт не может быть куплен вместе с продуктами которые уже имеются в вашей корзине.';
msg['MSG_MIXED_CART']='.Этот продукт не может быть куплен вместе с продуктами которые уже имеются в вашей корзине';
msg['MSG_INSUFFICIENT_STOCK']='К сожалению, на данный момент мы не имеет в наличии этот товар';
msg['MSG_APPLIEDVATCHANGED']= 'Изменение платёжной информации, необходимо просто перезагрузить страницу завершения..';
msg['MSG_GENERIC_ERROR']='К сожалению, произошла ошибка.';
msg['MSG_RECOVEREMAILSENT']='Вы только что получил письмо с дальнейшими инструкциями.';
msg['MSG_EXTRAUELIMIT']='Вы не можете подтвердить заказы с общей  суммой(исключая сборов) меньше, чем € 2000.00 &;';
msg['MSG_COUPON_ERROR']=' Введеный код купона  не действителен или уже использован.';
msg['MSG_COUPON_VALID']='Введеный код купона успешно принят.';
msg['MSG_RULE_REJECT']='Product cannot be added to cart because of rule :rule';
msg['LABEL_ARTICLES']='Артикли';
msg['LABEL_WARNING']='Предупреждение';
msg['LABEL_NOTAPPLICABLE']='Не применимо';
msg['LABEL_ALREADYREGISTEREDUSERES']='Уже зарегистрированные пользователи';
msg['LABEL_SENTINVITES']='Отправленные приглашения';
msg['LABEL_NOTSENTINVITES']='Неотправленные приглашает';
msg['LABEL_INVITES_ALREADY_SENT']='Люди уже приглашены';
msg['LABEL_SUBMIT']='Войти';
msg['LABEL_SELECTALL']='Выбрать все';
msg['MSG_MESSAGE_SENT']='Сообщение отправлено';
msg['MSG_PROFILECONSENT_SAVED'] = 'Ваши контактные предпочтения были обновлены';
msg['Login to your account'] = 'Пользователь уже существует';
msg['msg.form.invalidtype'] = 'Произошла ошибка. Пожалуйста, свяжитесь с администрацией, сообщив следующее: "Неверный или отсутствующий тип контакта."';
msg['msg.form.invalidemail'] = 'Неверный или отсутствующий адрес электронной почты';
msg['msg.form.invalidrecipients'] = 'Произошла ошибка. Свяжитесь с администрацией, сообщив следующее: "Получатель контакта недействителен или отсутствует."';
msg['ERR_WRONG_TOKEN'] = 'Введенный вами токен неверен';
msg['MSG_PSW_COMPLEX_INSTRUCTIONS'] = 'Пароль должен состоять не менее чем из 8 символов и содержать как минимум одну цифру, одну заглавную и одну строчную букву.';
msg['login.user.unexisting'] = 'Пользователь не существует';
msg['MSG_PASSWORD_OK'] = 'Пароль изменен правильно';
msg['MSG_TOKEN_SENT'] = 'Проверьте свою электронную почту и вставьте токен, чтобы сбросить пароль';

var portal_livestock_available='ДОСТУПНЫ';
var portal_livestock_soldout='ПРОДАНО';

var activity_online_shop = 'интернет-магазин';
var activity_shop = 'магазин';
var activity_private_sales = 'приватные продажи';
var activity_outlet = 'оутлет';
var activity_online_outlet = 'онлайн оутлет';
var activity_store_chain = 'Сеть магазинов';
var activity_purchasing_group = 'группа закупок';
var activity_broker = 'Брокер / агент';
var activity_ebay_amazon = 'Ebay / Amazon магазин';
var activity_other = 'другой';

var general='Главные, генеральные';
var general_personaldata='Личные данные';
var general_olduser='Зарегистрированный пользователь';
var general_newuser='Новый пользователь';
var general_username="Имя пользователя";
var general_password="Пароль";
var general_contacts='Контакты';
var general_phone='Номер Телефона';
var general_skype='Skype';
var general_website='Сайт';
var general_fax='Факс';
var general_firstname='Имя';
var general_lastname='Фамилия';
var general_company='Компания';
var general_birth='Дата рождения';
var general_code='Код';
var general_model='Модель';
var general_quantity='Количество';
var general_availability='наличие';
var general_price='цена';
var general_warning='Предупреждение';
var general_dispatchto='Название фирмы / адрес';
var general_careof='Вывеска фирмы';
var general_vat='НДС';
var general_address='Адрес';
var general_addresstype='тип адреса';
var general_addressnumber='Номер';
var general_city='Город';
var general_prov='Область';
var general_zip='Индекс';
var general_mobile='Мобильный';
var general_notes='Примечания';
var general_orders='заказы';
var general_fgfdiscounts='Друзья и скидки';
var general_myprofile='Мой Профиль';
var general_pieces='ПК';
var general_size_table='Таблица размеров';
var general_details='Подробнее';
var general_invoice='Счет-фактура';
var general_creditnote='кредитовое авизо';
var general_cart= 'Корзина';
var general_country='страна';
var general_carrier='перевозчик';
var general_dispatch_address= 'Адрес отправки';
var general_invoice_address='Адрес выставления счета';
var general_receive_newsletter='Получить рассылку';
var general_copydispatchfrombilldata='копировать данные счета-фактуры';
var general_instructions="инструкции";
var general_add="добавить";
var general_status="статус";
var general_toomanyfilters="Вы достигли максимального количества разрешенных фильтров.";

var help_addresstype='улица, площадь, переулок, ...';
var help_address='название улицы';
var help_dispatchmobile='Этот номер будет использоваться перевозчиком.';
var help_ordercfpiva='Пустое бланк будет автоматически добавлять 20% НДС от стоимости заказа.';
var help_cf='Впишете номер социального страхования';

var buttons_save='Сохранить';
var buttons_changepw='изменить пароль';
var buttons_close='Закрыть';
var buttons_continue='продолжить';
var buttons_confirm='подтвердить';
var buttons_cancel='стереть';
var buttons_invite='пригласить';
var buttons_continueshopping='Продолжить с покупками';
var buttons_gocheckout='Перейти к заказу';

var messages_product_soldout='Продукт продан.';
var messages_noselection='Ничего не выбрано';
var messages_invaliddata='Неверные данные.';
var messages_recoverpassword='Восстановить пароль';
var messages_recoverpassword_info='Укажите Вашу электронную почту и Вы получите письмо с инструкцией, как  восстановить пароль';
var messages_invitefriends='Пригласить друзей';
var messages_confirmpassword='Подтвердите пароль';
var messages_sendingmail='Отправка почты..';
var messages_mailsent='E-mail отправлен.';
var messages_password='Пароль';
var messages_requiredfield='Необходимо заполнить';

var subscribe_personaldata='Личные данные';
var subscribe_privacyintro='Вы должны принять следующее условие, чтобы продолжить подписку.';
var subscribe_privacydisclaimer='Вы должны принять отказ от конфиденциальности, чтобы приступить к подписке.';
var subscribe_privacy1='Я принимаю отказ  от конфиденциальности';
var subscribe_privacy2='Я признаю, что мои личные данные могут быть использованы другими фирмами в маркетинговых кампаний (по желанию)';

var order_status='Статус';
var order_date='Дата';
var order_dispatchdate='Отправлено';
	
var returnedgoods_requests="Возможность возвратить товар";
var returnedgoods_motivations="Причина для возвращения товара";
var returnedgoods_requestcode="Код запроса Возвращенные товары";
var returnedgoods_requestdate="Дата заказа";
var returnedgoods_motivations_1="Мне не нравится продукт";
var returnedgoods_motivations_2="Продукт является слишком большой / маленький";
var returnedgoods_motivations_3="Продукт поврежден";
var returnedgoods_motivations_4="Продукт не соответствует заказанному ";
var returnedgoods_motivations_5="Продукт не в пакете";
var returnedgoods_motivations_other="другое";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='В ожидании';
i18nOrderStatus[1]='Ожидание платежа';
i18nOrderStatus[2]='Подтверждено';
i18nOrderStatus[3]='Выслано';
i18nOrderStatus[4]='Доставлено';
i18nOrderStatus[5]='Забронировано';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Отменена';
i18nOrderStatus[2001]='Ошибка';
i18nOrderStatus[3001]='В обработке';
i18nOrderStatus[3002]='Готово';

i18nOrderStatus[1000]='Платеж отменён';
i18nOrderStatus[2002]='Не удалось проверить платеж';
i18nOrderStatus[2003]='Деньги возвщены';
i18nOrderStatus[2005]='Отклонено';
i18nOrderStatus[3003]='Не поставляется товар';
i18nOrderStatus[5001]='Не разрешено';
i18nOrderStatus[5002]='Разрешено';
i18nOrderStatus[5003]='Dropshipping - Growing';